<template>
  <Switch
    :default-value="modelValue"
    :model-value="modelValue"
    @update:model-value="updateModelValue"
  />
</template>

<script setup>
import { Switch } from '@/shadcn/components/ui/switch'
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  modelValue: Boolean,
});

// Emits
const emit = defineEmits([
  'update:modelValue',
]);

// Update modelValue
const updateModelValue = (newValue) => {
  emit('update:modelValue', newValue);
};
</script>
